import {Analytics} from "@plaudit/analytics";
import { __experimentalInputControlPrefixWrapper } from "@wordpress/components";

// Setup the system and return an instance of Analytics.
Analytics.setup();

window.addEventListener("message", (event: MessageEvent) => {
	if (
		typeof event.data === "object"
		&& event.origin.indexOf("jotform.com") !== -1
		&& event.data.action === "submission-completed"
		&& window.gtag !== undefined
		&& event.target !== undefined
	) {

		// basically, is this an injected iframe or not
		let iframe = (event.target as any).iframe || (event.target as any).ifr;
		if (!iframe && event.data.formID) {
			iframe = document.getElementById( event.data.formID );
		}
		let googleEvent = "jotform_submission";

		if (iframe) {
			if (iframe.dataset.googleEvent) {
				googleEvent = iframe.dataset.googleEvent;
			} else {
				const valueHolder = iframe.closest("[data-google-event]");
				if (valueHolder?.dataset.googleEvent) {
					googleEvent = valueHolder.dataset.googleEvent;
				}
			}
		}

		gtag('event', googleEvent);
	}
}, false);